import { render, staticRenderFns } from "./genes.vue?vue&type=template&id=2a6c1a7d&scoped=true&"
import script from "./genes.vue?vue&type=script&lang=js&"
export * from "./genes.vue?vue&type=script&lang=js&"
import style0 from "./genes.vue?vue&type=style&index=0&id=2a6c1a7d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6c1a7d",
  null
  
)

export default component.exports